export default __webpack_public_path__ + "static/icon--youtube-9e0a06908faabfd4967ed386458c4f4d.png";